<template>
  <div class="newpass">
    <div class="contetn-container">
      <h2>رمز عبور جدید</h2>
      <form @submit.prevent="submit" class="newpass-container">
        <div class="input-container">
          <div class="spans">
            <span class="input-span"> کد تایید </span>
          </div>
          <label class="no-just">
            <input v-model="data.code" name="otp" style="width: 100%" />
          </label>
          <span @click="counter ? null : resendBtn()" class="counter">
            {{ counter ? counter : "ارسال مجدد کد" }}
          </span>
        </div>

        <div class="input-container">
          <div class="spans">
            <span class="input-span"> رمز عبور جدید </span>
          </div>
          <label class="no-just">
            <input
              v-model="data.password"
              :type="showpass ? 'text' : 'password'"
              style="width: 100%"
            />
            <img
              @click="showpass = true"
              v-if="!showpass"
              src="../../assets/icons/dontseepassword.svg"
              alt=""
            />
            <img
              @click="showpass = false"
              v-if="showpass"
              class="seepass"
              src="../../assets/icons/seepassword.svg"
              alt=""
            />
          </label>
        </div>
        <div class="input-container">
          <div class="spans">
            <span class="input-span"> تکرار رمز عبور </span>
          </div>
          <label>
            <input
              v-model="data.passRepeat"
              :type="showRepeat ? 'text' : 'password'"
              style="width: 100%"
            />
            <img
              @click="showRepeat = true"
              v-if="!showRepeat"
              src="../../assets/icons/dontseepassword.svg"
              alt=""
            />
            <img
              @click="showRepeat = false"
              v-if="showRepeat"
              class="seepass"
              src="../../assets/icons/seepassword.svg"
              alt=""
            />
          </label>
        </div>
        <button :disabled="disable" class="submit" type="submit">
          {{ disable ? disable : "تایید" }}
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import { paste } from "@/library/reuseableFunction";

export default {
  name: "NewPass",
  data() {
    return {
      showpass: false,
      showRepeat: false,
      data: {
        passRepeat: null,
        password: null,
        code: "",
        username: this.$cookies.get("username"),
      },
      counter: 120,
      timeOut: null,
    };
  },
  computed: {
    disable() {
      let err;
      if (this.counter == 0) {
        err = "زمان شما به پایان رسیده است";
      } else if (!this.data.password) {
        err = "رمز جدید را وارد کنید";
      } else if (!this.$validPass(this.data.password)) {
        err = "رمز باید شامل حروف بزرگ کوچک و عدد باشد";
      } else if (this.data.password.length < 8) {
        err = "رمز باید حداقل شامل ۸ کاراکتر باشد";
      } else if (!this.data.passRepeat) {
        err = "تکرار رمز را وارد کنید";
      } else if (this.data.passRepeat !== this.data.password) {
        err = "رمز با تکرارش تشابه ندارد";
      } else if (this.data.code.length != 6) {
        err = "کد تایید را وارد کنید";
      } else {
        err = false;
      }
      return err;
    },
  },
  methods: {
    paste,
    countDownTimer() {
      if (this.counter > 0) {
        this.timeOut = setTimeout(() => {
          this.counter--;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$error("زمان شما به اتمام رسید", "");
      }
    },
    async resendBtn() {
      this.state.loaading = true;
      let body = {};
      if (this.$validEmail(this.data.username)) {
        body.email = this.data.username;
        body.authenticationType = "EMAIL";
      } else {
        body.mobileNumber = this.data.username;
        body.authenticationType = "SMS";
      }
      await this.$axios.post("/users/forget-password", body);
      this.$error("کد جدید برای شما ارسال شد", "", "success");

      if (this.counter === 0) {
        this.counter = 120;
        this.countDownTimer();
      }
    },
    async submit() {
      if (!this.disable) {
        this.state.loading = true;
        await this.$axios.post("/users/reset-password", this.data);
        this.$error("رمز شما با موفقیت تغییر یافت", "", "success");
        this.$router.push({ name: "Login" });
      }
    },
  },
  mounted() {
    this.countDownTimer();
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  label {
    justify-content: space-around;
    img {
      cursor: pointer;
    }
  }
}
.newpass {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  justify-self: center;
  z-index: 5;
}
.contetn-container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 30%;
}
.newpass-container {
  row-gap: 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 12px;
  background: white;
}
@media only screen and (max-width: 1300px) {
  .contetn-container {
    width: 50%;
  }
}
@media only screen and (max-width: 1100px) {
  .contetn-container {
    width: 70%;
  }
}
@media only screen and (max-width: 900px) {
  .contetn-container {
    width: 85%;
  }
}
@media only screen and (max-width: 600px) {
  .contetn-container {
    width: 100%;
  }
}
.counter {
  cursor: pointer;
  align-self: start;
}
</style>
